import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`

export const FeaturesList = styled.ul`
  margin-left: ${Spacing.S8};
  list-style: inside;
`
